var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10182 5.21923V18.0006H10.6659V5.21923L16.1698 10.9432L17.9826 9.0579L9.38387 0.115234L0.785156 9.0579L2.59798 10.9432L8.10182 5.21923Z",
    fill: "#74BF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGreen);
export default __webpack_public_path__ + "static/media/arrowUpGreen.77dd155a1745518fe15a27dd07c7a227.svg";
export { ForwardRef as ReactComponent };